import React from "react";
import FieldGroup from "../FieldGroup";
import FormSection from "../FormSection";
import { CheckBox, Dropdown, File, Radio, TextArea, TextField } from "../Input";
import Canvas from "../Input/Canvas";
import PhoneInput from "../Input/PhoneInput";

const Field = ({ field, parent }) => {

  if (field?.field_type?.includes("sect-title"))
    return (
      <FormSection title={field.field_label} isRequired={field?.is_required} />
    );

  if (field?.field_type?.includes("textarea"))
    return (
      <TextArea parent={parent} {...field} isRequired={field?.is_required} charactersRange={field?.characters_range} />
    );

  if (field?.field_type?.includes("checkbox"))
    return (
      <CheckBox parent={parent} {...field} isRequired={field?.is_required} />
    );

    if (field?.field_type?.includes("dropdown") || field.field_key === 'dropdown')
    return (
      <Dropdown parent={parent} {...field} isRequired={field?.is_required} />
    );
  if (field?.field_type == "business-sector" || field?.field_type?.includes('business-sector'))
    return (
      <Dropdown parent={parent} {...field} isRequired={field?.is_required} />
    );
  if (field?.field_type?.includes("radio")){
    return <Radio parent={parent} {...field} isRequired={field?.is_required} />;
  }

  if (field?.field_type?.includes("file"))
    return <File parent={parent} {...field} isRequired={field?.is_required} />;

  if (field?.field_type?.includes("number") && field.field_label.includes("phone_number")) {
    return (
      <PhoneInput parent={parent} {...field} isRequired={field?.is_required} />
    );
  }
  
  if ( 
    field.field_type?.includes('input') ||
    field.field_type?.includes("number") ||
    field.field_type?.includes("date") ||
    field.field_type?.includes("currency") ||
    field.field_type?.includes("location")
  )
    return <TextField parent={parent} {...field} isRequired={field?.is_required}/>;

  if (field?.field_type?.includes("signature"))
  return <Canvas parent={parent} {...field} />;

  return <FieldGroup parent={parent} {...field} />;
};

export default Field;
